import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

export function createStore() {
  return new Vuex.Store({
    state: {
      host: '',
      currentLocale: {},
      locales: [],
      categories: [],
      shop: {},
      shopCoupons: [],
      shopCouponsCount: 0,
      shopFiltersCount: {},
      shopCoupon: {},
      shopCouponsExpired: [],
      subdomain: '',
      subdomainsEnabed: false,
      popularShops: {}
    },
    actions,
    mutations,
  });
};